module.exports = __webpack_public_path__ + "static/urban1-480d9b7cf593844b2b11e984f3137206.jpg";